import type { Profile } from 'models';
import { useMemo } from 'react';

export const usePushNotificationSettings = ({ viewer }: { viewer: Profile }) =>
  useMemo(
    () => ({
      enableNotifications: viewer.pushNotificationsSettings?.enableNotifications?.value ?? false,
      events: viewer.pushNotificationsSettings?.events?.value ?? false,
      giving: viewer.pushNotificationsSettings?.giving?.value ?? false,
      messaging: viewer.pushNotificationsSettings?.messaging?.value ?? false,
      newsfeed: viewer.pushNotificationsSettings?.newsfeed?.value ?? false,
      program: viewer.pushNotificationsSettings?.program?.value ?? false,
    }),
    [
      viewer.pushNotificationsSettings?.enableNotifications?.value,
      viewer.pushNotificationsSettings?.events?.value,
      viewer.pushNotificationsSettings?.giving?.value,
      viewer.pushNotificationsSettings?.messaging?.value,
      viewer.pushNotificationsSettings?.newsfeed?.value,
      viewer.pushNotificationsSettings?.program?.value,
    ],
  );
